<template>
  <div class="order-submit">
    <div class="head-nav-fff d-aligncnter">
      <div class="nav-left d-allcenter" @click="pageToBack"><img src="@/assets/img/appointment/backgrey.svg" /></div>
      <div class="nav-title d-allcenter overflow">订单确认</div>
      <div class="nav-right"></div>
    </div>
    <div style="padding-top: 44px">
      <el-alert
        v-if="cancelTime > 0"
        :title="'还剩' + getCancelTime + '订单自动取消'"
        type="error"
        :closable="false"
        center
      >
      </el-alert>
      <el-alert v-else :title="'订单已取消！'" type="error" :closable="false" center> </el-alert>
      <div class="info-box">
        <div class="d-aligncnter">
          <div style="width: 80px; height: 80px; border-radius: 2px; overflow: hidden" class="d-allcenter">
            <el-image
              style="width: 80px; height: 64px"
              :src="require('@/assets/img/appointment/demo.png')"
              fit="cover"
            ></el-image>
          </div>
          <div style="margin-left: 16px; font-size: 14px; width: calc(100% - 100px)">
            <div class="weight overflow2">
              {{ currOrderData.venueName }}（{{ currOrderData.areaName }}{{ currOrderData.blockName }}）
            </div>
            <div class="grey mt-4">{{ currOrderData.date }} {{ currOrderData.time }}</div>
            <div class="grey mt-4">入场方式：人脸识别</div>
          </div>
        </div>
      </div>
      <div class="normal-box">
        <div class="d-aligncnter" style="">
          <div class="d-aligncnter" style="width: 50%">
            <img src="@/assets/img/appointment/user.svg" />
            <div class="ml-8" v-if="!editStatus">{{ currOrderData.userName }}</div>
            <div v-else class="ml-8" style="margin-right: 8px">
              <el-input v-model="userInfo.name" placeholder="请输入姓名"></el-input>
            </div>
          </div>
          <div class="d-aligncnter">
            <img src="@/assets/img/appointment/tel.svg" />
            <div class="ml-8" v-if="!editStatus">{{ currOrderData.mobile }}</div>
            <div v-else class="ml-8">
              <el-input v-model="userInfo.phone" placeholder="请输入手机号" maxlength="11"></el-input>
            </div>
          </div>
        </div>
        <!-- <div class="d-between d-aligncnter" style="padding-top: 8px">
          <div class="grey">仅用于异常时便于我们联系到您</div>
          <img v-if="!editStatus" src="@/assets/img/appointment/edit.svg" @click="editStatus = true" />
          <button
            v-else
            @click="editStatus = false"
            class="submit"
            style="border: none; padding: 0px; width: 60px; font-size: 12px; height: 28px"
          >
            确定
          </button>
        </div> -->
      </div>
      <div class="normal-box" v-if="cancelTime > 0">
        <div class="d-between" @click="pageToAddFriends">
          <div class="d-aligncnter" style="width: 50%">
            <div class="d-allcenter plus">
              <img src="@/assets/img/appointment/add-plus.svg" />
            </div>
            <div class="ml-8">邀请伙伴</div>
          </div>
          <div class="d-aligncnter">
            <div class="grey">已选{{ friendList.length }}人</div>
            <img
              src="@/assets/img/appointment/backgrey.svg"
              class="transform-180"
              style="width: 16px; height: 16px; margin-left: 8px"
            />
          </div>
        </div>
        <div
          class="d-between fs-sm"
          style="padding-left: 32px; margin-top: 8px"
          v-for="(item, index) in friendList"
          :key="'f_' + index"
        >
          <div>{{ item.name }}</div>
          <div class="grey d-aligncnter">
            {{ item.mobile }}
            <img style="margin-left: 8px" src="@/assets/img/appointment/delete-one.svg" @click="removeFriend(index)" />
          </div>
        </div>
        <!-- <div class="d-between fs-sm" style="padding-left: 32px; margin-top: 8px">
          <div>李四</div>
          <div class="grey d-aligncnter">
            125****8888 <img style="margin-left: 8px" src="@/assets/img/appointment/delete-one.svg" />
          </div>
        </div> -->
      </div>

      <div class="normal-box d-between" v-if="cancelTime > 0" @click="pageToFp">
        <div class="d-aligncnter" style="width: 50%">
          <img src="@/assets/img/appointment/fp.svg" />
          <div class="ml-8">发票</div>
        </div>
        <div class="d-aligncnter">
          <div class="grey">{{ currOrderData.invoice }}</div>
          <img
            src="@/assets/img/appointment/backgrey.svg"
            class="transform-180"
            style="width: 16px; height: 16px; margin-left: 8px"
          />
        </div>
      </div>
      <div class="normal-box" v-if="cancelTime > 0">
        <div class="weight fs-sm">支付方式</div>
        <div
          class="d-between"
          v-for="(item, index) in payWays"
          :key="'way_' + index"
          style="line-height: 42px; border-bottom: 1px solid #f9f9f9"
          @click="payIndex = index"
        >
          <div class="d-aligncnter">
            <img :src="item.icon" style="width: 20px; height: 20px" />
            <div class="ml-8 fs-sm">{{ item.name }}</div>
          </div>
          <div><i class="el-icon-success" v-if="payIndex == index" style="color: #339571; font-size: 20px"></i></div>
        </div>
      </div>
      <div class="normal-box">
        <div class="d-between">
          <div class="weight fs-sm">订单信息</div>
          <!-- <div class="d-aligncnter grey">
            展开<img
              src="@/assets/img/appointment/backgrey.svg"
              class="transform-90 ml-8"
              style="width: 16px; height: 16px"
            />
          </div> -->
        </div>
        <div class="d-between mt-8" style="color: #2f2f2f">
          <div class="fs-xs">订单编号</div>
          <div class="grey">{{ currOrderData.orderNum }}</div>
        </div>
        <div class="d-between mt-8" style="color: #2f2f2f">
          <div class="fs-xs">创建时间</div>
          <div class="grey">{{ currOrderData.createTime }}</div>
        </div>
      </div>
      <!-- <div class="order-line">
        <div class="d-aligncnter d-between">
          <div style="width: 80px; height: 80px; border-radius: 2px; overflow: hidden" class="d-allcenter">
            <el-image
              style="width: 80px; height: 80px"
              :src="require('@/assets/img/appointment/demo.png')"
              fit="cover"
            ></el-image>
          </div>
          <div>
            <div>北校区XX场馆</div>
          </div>
        </div>
        <div></div>
      </div> -->
      <!-- <div class="order-line mt-8 d-between">
        <div>场地</div>
        <div>网球场</div>
      </div>
      <div class="order-line mt-8 d-between">
        <div>时间</div>
        <div>2024-01-22 8:00-9:00</div>
      </div>
      <div class="order-line mt-8 d-between">
        <div>联系方式</div>
        <div>1526778999</div>
      </div> -->
    </div>
    <div class="d-between bottom-sub d-aligncnter" v-if="cancelTime > 0">
      <div style="font-size: 12px; height: 48px" class="d-aligncnter">
        <div class="d-flex need d-aligncnter" style="flex-wrap: wrap">
          <el-checkbox v-model="mustCheck">已阅读并同意</el-checkbox>
          <div class="fs-sm d-flex" style="margin-top: 2px">
            <div class="knew" @click="showLayer">预约须知</div>
          </div>
        </div>
      </div>
      <div class="submit d-allcenter" style="white-space: nowrap" @click="goToPay">
        <span style="font-size: 12px; font-weight: 400">￥</span
        ><span v-if="currOrderData.mode">{{ currOrderData.price * (friendList.length + 1) }} </span
        ><span v-else>{{ currOrderData.price }}</span
        ><span style="margin-left: 8px">立即付款</span>
      </div>
    </div>
    <el-dialog title="预约须知" :visible.sync="needshow" width="80%">
      <div class="need-content fs-xs font-0" v-html="instructionsBook"></div>
    </el-dialog>
    <el-dialog title="预约须知" :visible.sync="needshowCheck" width="80%">
      <div class="need-content fs-xs font-0" v-html="instructionsBook"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="needshowCheck = false">关闭</el-button>
        <el-button type="primary" @click="toCheckMust">已读且同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import { getCurrConference, payment, getInstructionsBook } from '@/api/api-venueOrder'
export default {
  components: {},
  data() {
    return {
      title: '订单确认',
      needshow: false,
      cancelTime: 1800,
      mustCheck: false,
      editStatus: false,
      userInfo: {
        name: '张三',
        phone: '15268808990',
      },
      conferenceId: '',
      currOrderData: {},
      friendList: [
        // {
        //   name: '张三',
        //   phone: '15268808990',}
      ],
      currPrice: '',
      needshowCheck: false,
      instructionsBook: '',
      payWays: [
        { name: '微信', icon: require('@/assets/img/appointment/WeChat.svg') },
        { name: '支付宝', icon: require('@/assets/img/appointment/alipay.svg') },
      ],
      payIndex: 0,
    }
  },
  mounted() {
    setInterval(() => {
      if (this.cancelTime > 0) {
        this.cancelTime--
      }
    }, 1000)
    this.conferenceId = this.$route.query.conferenceId
    console.log('conferenceId', this.conferenceId)
    this.getCurrConferenceData()
    this.getInstructionsBookData()

    if (localStorage.getItem('friendlist')) {
      this.friendList = JSON.parse(localStorage.getItem('friendlist'))
    }
    console.log('friendList', localStorage.getItem('friendlist'))
    console.log('friendList', this.friendList)
  },

  computed: {
    getCancelTime() {
      var minutes = Math.floor((this.cancelTime % 3600) / 60)
      var remainingSeconds = this.cancelTime % 60
      return minutes.toString().padStart(2, '0') + ':' + remainingSeconds.toString().padStart(2, '0')
    },
  },
  methods: {
    getInstructionsBookData() {
      getInstructionsBook().then((res) => {
        if (res.data.statusCode == 1) {
          this.instructionsBook = res.data.obj.instructionsBook
        } else {
          Message.error(res.data.message)
        }
      })
    },
    removeFriend(index) {
      this.friendList.splice(index, 1)
      localStorage.setItem('friendlist', JSON.stringify(this.friendList))
    },
    pageToBack() {
      this.$router.go(-1)
    },
    showLayer() {
      //   this.needshow = true
      this.needshowCheck = true
    },
    goToPay() {
      if (this.cancelTime > 0) {
        if (this.mustCheck) {
          console.log('去支付')
          let friend = []
          this.friendList.forEach((item) => {
            friend.push(item.id)
          })
          payment(this.conferenceId, friend).then((res) => {
            if (res.data.statusCode == 1) {
              console.log('res:', res)
              localStorage.setItem('friendlist', [])
              this.$router.push({
                path: '/appointment/paid',
                query: { conferenceId: this.conferenceId },
              })
            } else {
              Message.error(res.data.message)
            }
          })
        } else {
          Message.error('请阅读勾选预约须知')
          this.needshowCheck = true
        }
      } else {
        Message.error('订单已超时请重新选择！')
      }
    },
    toCheckMust() {
      this.mustCheck = true
      this.needshowCheck = false
    },
    pageToAddFriends() {
      this.$router.push({
        path: '/appointment/invite',
      })
    },
    pageToFp() {
      this.$router.push({
        path: '/appointment/invoice',
        query: { conferenceId: this.conferenceId, invoice: this.currOrderData.invoice },
      })
    },
    getCurrConferenceData() {
      getCurrConference(this.conferenceId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.currOrderData = res.data.obj
          this.cancelTime = 1800 - res.data.obj.millis > 0 ? 1800 - res.data.obj.millis : 0
        } else {
          Message.error(res.data.message)
        }
      })
    },
    refreshInvoice() {
      getCurrConference(this.conferenceId).then((res) => {
        if (res.data.statusCode == 1) {
          console.log('res:', res)
          this.currOrderData.invoice = res.data.obj.invoice
          this.cancelTime = 1800 - res.data.obj.millis > 0 ? 1800 - res.data.obj.millis : 0
        } else {
          Message.error(res.data.message)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';
.order-submit {
  height: calc(100vh - 77px);
  background: #f9f9f9;
  overflow: scroll;
}

.mt-8 {
  margin-top: 8px;
}
.pt-16 {
  padding: 16px;
}
.submit {
  background: linear-gradient(270deg, #2f2f2f 0%, #464646 100%);
  border-radius: 52px;
  color: #fff;
  width: 100px;
  height: 32px;
  font-size: 14px;
  padding: 8px 16px;
  font-weight: 600;
}
.order-line {
  width: calc(100% - 32px);
  background: #fff;
  padding: 16px;
  font-size: 14px;
}
.bottom-sub {
  position: fixed;
  bottom: 0;
  left: 0;
  width: calc(100% - 32px);
  height: 48px;
  padding: 16px;
  background: #e6f2ed;
}
.knew {
  color: #009afe;
  margin-left: 8px;
  text-decoration: underline;
}
.info-box {
  border-radius: 8px;
  background: linear-gradient(302deg, #e6f2ed 0%, #fff8e7 100%), #fff;
  box-shadow: 0px 2px 4px 0px #e8e8e8;
  margin: 16px;
  padding: 16px;
}
.normal-box {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px #e8e8e8;
  margin: 16px;
  padding: 16px;
}
.mt-4 {
  margin-top: 4px;
}
.ml-8 {
  margin-left: 8px;
}
.transform-180 {
  transform: rotate(180deg);
}
.transform-90 {
  transform: rotate(-90deg);
}

.need ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #339571;
  border-color: #339571;
}
.need ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #339571;
}
.need ::v-deep .el-checkbox__inner:hover {
  border-color: #339571 !important;
}
.need ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #339571 !important;
}
.need ::v-deep .el-checkbox__label {
  padding-top: 3px;
}

.plus {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background: var(--Icon-Gradient-Orange, linear-gradient(110deg, #fa904f 10.99%, #ff6100 89.01%));
}
</style>
